export default __webpack_public_path__ + "static/media/edit-new-icon-grey.9d8ecc56.svg";